export default {
  sidebarWidth: '28%',
  sidebarWidthTablet: '52px',
  sidebarMaxWidth: '420px', // Limite para evitar sidebar muito grande em zoom alto
  sidebarMinWidth: '280px', // Mínimo para garantir legibilidade
  drawerWidthDesktop: '360px',
  drawerWidthTablet: '320px',
  drawerHeightPhone: '250px',
  filterFormWidth: '160px',
  eventsDrawerWidth: '320px',
  bottomBarHeight: 56,
  bottomPanelMaxHeight: '180px', // Limite para zoom alto
  popupMapOffset: 300,
  popupMaxWidth: 300,
  popupImageHeight: 144,
  cardContentMaxHeight: '40vh',
  qrCodeSize: 192,
};
